import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ErrorService } from '@eforall/common';
import { DialogService } from '../../services';
import { DashboardErrorGenericDataPart } from './error-data-generic/error-generic-data.part';
import { DashboardErrorUnverifiedEmailPart } from './error-unverified-email/error-unverified-email.part';


@Component({
	selector: 'dashboard-error-part',
	imports: [DashboardErrorGenericDataPart, DashboardErrorUnverifiedEmailPart],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './error.part.html'
})
export class DashboardErrorPart {
	public errorService = inject(ErrorService);
	public dialogService = inject(DialogService);

	constructor() { this.dialogService.closeAll(); }
}